/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface AdminDataPersonDTO
 */
export interface AdminDataPersonDTO  {
    /**
     * 
     * @type {number}
     * @memberof AdminDataPersonDTO
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof AdminDataPersonDTO
     */
    changed?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AdminDataPersonDTO
     */
    created?: Date;
    /**
     * 
     * @type {string}
     * @memberof AdminDataPersonDTO
     */
    deskman?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDataPersonDTO
     */
    editorialStatus?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDataPersonDTO
     */
    hidden?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminDataPersonDTO
     */
    origin?: string;
    /**
     * 
     * @type {Date}
     * @memberof AdminDataPersonDTO
     */
    dataLastSupplied?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AdminDataPersonDTO
     */
    personChecked?: Date;
}

/**
 * Check if a given object implements the AdminDataPersonDTO interface.
 */
export function instanceOfAdminDataPersonDTO(value: object): value is AdminDataPersonDTO {
    return true;
}

export function AdminDataPersonDTOFromJSON(json: any): AdminDataPersonDTO {
    return AdminDataPersonDTOFromJSONTyped(json, false);
}

export function AdminDataPersonDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminDataPersonDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                'changed': json['changed'] == null ? undefined : (new Date(json['changed'])),
                'created': json['created'] == null ? undefined : (new Date(json['created'])),
                  'deskman': json['deskman'] == null ? undefined : json['deskman'],
                  'editorialStatus': json['editorialStatus'] == null ? undefined : json['editorialStatus'],
                  'hidden': json['hidden'] == null ? undefined : json['hidden'],
                  'origin': json['origin'] == null ? undefined : json['origin'],
                'dataLastSupplied': json['dataLastSupplied'] == null ? undefined : (new Date(json['dataLastSupplied'])),
                'personChecked': json['personChecked'] == null ? undefined : (new Date(json['personChecked'])),
    };
}

export function AdminDataPersonDTOToJSON(json: any): AdminDataPersonDTO {
    return AdminDataPersonDTOToJSONTyped(json, false);
}

export function AdminDataPersonDTOToJSONTyped(value?: AdminDataPersonDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'changed': value['changed']?.toISOString(),
        'created': value['created']?.toISOString(),
        'deskman': value['deskman'],
        'editorialStatus': value['editorialStatus'],
        'hidden': value['hidden'],
        'origin': value['origin'],
        'dataLastSupplied': value['dataLastSupplied']?.toISOString().substring(0,10),
        'personChecked': value['personChecked']?.toISOString().substring(0,10),
    };
}


